import gql from 'graphql-tag';
import { Content } from './content';

export default gql`
  fragment SharesItem on SharesItem {
    id
    network
    network_id
    identifier
    user_commentary
    share_at
    shared_at
    share_session_id
    clicks
    engagements
    content {
      ...Content
    }
  }
  ${Content}
`;
